// extracted by mini-css-extract-plugin
export default {"cls1":"mE_YH6J8f87lG41UkuDQ","cls2":"fg89bdpIlCInFNZi6Flb mE_YH6J8f87lG41UkuDQ"};